module.exports = __webpack_public_path__ + "img/picto_2.1e5dbf34.svg";